import { Component, Input, OnChanges } from '@angular/core';
import { ProspectData, ProspectSchema, StageSchema } from '@lsq-frontend/remote-services/ar-app';
import { FormGroup } from '@angular/forms';
import { DrApplicationService } from '../../service/dr-application-service';

@Component({
    selector: 'dr-review-base',
    template: ``
})
export class ReviewContainerBase implements OnChanges {
    @Input() currentStageSchema: StageSchema;
    @Input() formGroup: FormGroup;
    @Input() adminView = false;
    public prospect: ProspectData;
    public prospectSchema: ProspectSchema;
    public stageSchemas: StageSchema[];
    constructor(public _arService: DrApplicationService) {}

    public ngOnChanges(): void {
        this.prospect = { ...this._arService.getProspect() };
        this.prospectSchema = { ...this._arService.getProspectSchema() };
    }

    public getReviewableStageSchemas() {
        return (this.prospectSchema?.stageSchemas || []).filter(
            (stageSchema: StageSchema) =>
                stageSchema.isReviewable || (this.adminView && stageSchema.isAdminReviewable)
        );
    }
}
``;
